import React from 'react';

type SocialSourceType = 'X_TWEET' | 'X_ACCOUNT' | 'X_COMMUNITY' | string;

interface SocialSourceTypeChipProps {
  type?: SocialSourceType;
  className?: string;
}

const STYLE_BY_TYPE: Record<string, string> = {
  X_TWEET: 'border-cyan-500/40 bg-cyan-500/15 text-cyan-200',
  X_ACCOUNT: 'border-violet-500/40 bg-violet-500/15 text-violet-200',
  X_COMMUNITY: 'border-emerald-500/40 bg-emerald-500/15 text-emerald-200',
};

const SocialSourceTypeChip: React.FC<SocialSourceTypeChipProps> = ({
  type,
  className = '',
}) => {
  const normalizedType = (type ?? 'UNKNOWN').toUpperCase();
  const styleClass =
    STYLE_BY_TYPE[normalizedType] ??
    'border-gray-500/40 bg-gray-500/15 text-gray-200';

  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${styleClass} ${className}`}
    >
      {normalizedType}
    </span>
  );
};

export default SocialSourceTypeChip;
